export class CallUsNumberModel {
    phoneNumber: string;
    phoneNumberLink: string;
}
